import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import DrawerComponent from "../DrawerComponent";
import { useScreenWidth } from "../../SubscriptionPageV2/hooks";
import FirstResponderIcon from "Images/quiz/FirstResponder.svg";
import MilitaryIcon from "Images/quiz/Military.svg";
import StudentIcon from "Images/quiz/Student.svg";
import HealthcareWorkerIcon from "Images/quiz/HealthcareWorker.svg";
import styles from "./styles.module.scss";
import H2Font from "../H2Font";
import LargeFont from "../LargeFont";
import Button from "../Button";
import { useHistory } from "react-router";
import VerificationImg from "./images/Verification.jpg";
import { useDispatch, useSelector } from "react-redux";
import { setShowPopup } from "Root/profile/redux/actionCreators/makeActionCreator";
import { completeBannerEvent } from "Root/api/apiProfile";
import posthog from "posthog-js";
const icons = [StudentIcon, MilitaryIcon, HealthcareWorkerIcon, FirstResponderIcon];
const DiscountProgramPopup = () => {
    const dispatch = useDispatch();
    const [openDrawer, setOpenDrawer] = useState(false);
    const showPopup = useSelector((state) => state.user.showPopup);
    const history = useHistory();
    const isMobile = useScreenWidth() < 968;
    const unlock = () => {
        toggleDrawer(false)();
        posthog.capture("sheerid_modal_clicked");
        history.push("/app/home#discount");
    };
    const toggleDrawer = (value) => () => {
        setOpenDrawer(value);
        dispatch(setShowPopup(false));
        if (!value) {
            completeBannerEvent({ event: "show_discount_popup" });
            posthog.capture("sheerid_modal_closed");
        }
    };
    useEffect(() => {
        if (showPopup)
            setOpenDrawer(true);
    }, [showPopup]);
    return (_jsx(DrawerComponent, { extraClassName: styles.drawer_close_button, open: openDrawer, toggleDrawer: toggleDrawer, crossButton: true, anchor: isMobile ? "bottom" : "right", children: _jsxs("div", { className: styles.content, children: [_jsx("div", { className: styles.img, children: _jsx("img", { src: VerificationImg, alt: "" }) }), _jsxs("div", { className: styles.wrapper, children: [_jsx("div", { className: styles.icons, children: icons.map((icon, index) => (_jsx("img", { src: icon }, index))) }), _jsx(H2Font, { fontWeight: 400, children: "Are you a Student, Military, Healthcare Worker or First Responder?" }), _jsxs(LargeFont, { children: ["We want to show our appreciation by gifting you ", _jsx("b", { children: "20%" }), " off your next ", _jsx("b", { children: "6 orders" })] }), _jsx(Button, { className: styles.btn, onClick: unlock, children: "verify to unlock savings" })] })] }) }));
};
export default DiscountProgramPopup;
